// extracted by mini-css-extract-plugin
export var addressInput = "geocoder-module--address-input--tDLfH";
export var empty = "geocoder-module--empty--FD5EI";
export var result = "geocoder-module--result--fINra";
export var resultBox = "geocoder-module--result-box--z9jYB";
export var wrapper = "geocoder-module--wrapper--JM-Of";